\
<template>
  <div v-if="orderID" class="mb-2">
    <b-form @submit.prevent="submit">
      <label>{{ $t("functionControlMethod") }}</label>
      <v-select
        v-model="functionControlMethod"
        taggable
        :label="$t('title')"
        :options="functionControlOptions"
      >
        <template #search="{attributes, events}">
          <input
            class="vs__search"
            :required="!functionControlMethod"
            v-bind="attributes"
            v-on="events"
          />
        </template>
      </v-select>
      <table class="table table-striped">
        <tr>
          <th>{{ $t("product") }}</th>
          <th>{{ $t("lIcF") }}</th>
          <th>{{ $t("productLeft") }}</th>
          <th>{{ $t("rIcF") }}</th>
          <th>{{ $t("productRight") }}</th>
          <th>{{ $t("attenuation") }}</th>
          <th>{{ $t("return") }}</th>
          <th>{{ $t("comment") }}</th>
        </tr>
        <function-control-product-row
          v-for="product in functionControlList"
          :key="product.productID"
          v-model="functionControlList[product.productID]"
          :productid="product.productID"
          :itemdescription="product.description"
          :productright="product.rfc"
          :productleft="product.lfc"
          :options="options"
          :person="product.dimensionObjectDescription"
          :functioncontrolmethod="functionControlMethod"
        />
      </table>

      <div v-if="loading">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
      <div v-if="productCount < 1 && !loading">
        <p>
          {{ $t("noFunctionControl") }}
        </p>
      </div>
      <hr />
      <b-button v-if="productCount > 0" type="submit" class="btn btn-primary">{{
        $t("submit")
      }}</b-button>
    </b-form>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import FunctionControlProductRow from "./FunctionControlProductRow";
import {BForm, BButton} from "bootstrap-vue";
import {
  getFunctionControlDeliveryData,
  getFunctionControlDeliveryOptions,
  saveFunctionControlDelivery,
} from "../../services/functionControl";

import vSelect from "vue-select";

export default {
  components: {
    FunctionControlProductRow,
    BForm,
    BButton,
    vSelect,
  },
  props: {
    orderidProp: {
      required: false,
      type: String,
      default: null,
    },
    productidProp: {
      required: false,
      type: String,
      default: null,
    },
  },
  data() {
    return {
      functionControlList: [],
      data: {},
      options: {},
      functionControlOptions: ["Sealtester Variphone", "REAT", "Other"],
      functionControlMethod: "",
      loading: true,
    };
  },
  computed: {
    urlSearchParams() {
      return new URLSearchParams(window.location.search);
    },
    params() {
      return Object.fromEntries(this.urlSearchParams.entries());
    },
    orderID() {
      return this.orderidProp ?? this.params?.orderID;
    },
    productID() {
      return this.productidProp ?? this.params?.productID ?? null;
    },
    productCount() {
      return Object.keys(this.functionControlList).length;
    },
  },
  watch: {
    orderID() {
      this.fetchData();
    },
  },
  async created() {
    await this.fetchData();
    this.loading = false;
  },
  methods: {
    async fetchData() {
      this.functionControlList = await getFunctionControlDeliveryData({
        orderID: this.orderID,
        productID: this.productID,
      });
      this.options = await getFunctionControlDeliveryOptions({
        orderID: this.orderID,
        productID: this.productID,
      });
    },
    submit: async function () {
      await new Promise((resolve) => setTimeout(resolve, 0))
      
      const result = await saveFunctionControlDelivery({
        orderID: this.orderID,
        productID: this.productID,
        functionControlDelivery: this.functionControlList,
        functionControlMethod: this.functionControlMethod,
      });

      this.$emit("submit");

      const type = result.success ? "success" : "error";

      if (result.message) {
        this.$toasted.show(result.message, {type});
      }
    },
  },
};
</script>
<style>
.vs__dropdown-toggle {
  border-radius: 0;
}
</style>
